import { ChangelogItem } from '@evorait/pace-components';
export const CHANGELOGS: ChangelogItem[] = [
  {
    "version": "5.15.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Corrected issue leading to conflicting notification status updates on multiple devices [8160].",
        "Corrected issue leading to duplicate submission of material requests [8170].",
        "Corrected issue causing duplicate CRM submissions [8068].",
        "Prevent selection of past times when changing criticality [8277].",
        "Improved layout and formatting of the timesheet [8137]."
      ],
      "ADDED": [
        "Introduced warning message when entering future-dated EOW times [8309].",
        "Enabled support for requesting additional tasks on the same equipment or location [GoT, 7948].",
        "Implemented automatic prefill of serial numbers for rental tools [8211].",
        "In-app changelogs [8280].",
        "Improved mouse interaction on dashboard [8001].",
        "Added support for screenshots for issue reporting [7943].",
        "Enabled quick app upgrade during startup [8262]."
      ],
      "REMOVED": [
        "Removed legacy components related to material returns [8291].",
        "Removed outdated Cordova dependencies [7503].",
        "Removed legacy components specific to Asia [8289].",
        "Removed 'Add material' button from the material return screen [8243].",
        "Removed document feedback button for Astoria forms [8276]."
      ]
    }
  },
  {
    "version": "5.15.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved an issue that removed newly added address from manual timesheet entries when sharing across devices [8314]."
      ]
    }
  },
  {
    "version": "5.15.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Mandatory commercial info for both FOC and billable entries in time recording and material sections [8411]."
      ]
    }
  },
  {
    "version": "5.15.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved SPQ form getting locked for the user."
      ]
    }
  },
  {
    "version": "5.16.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Documentation of reason for not filling the provided protocols [7916]",
        "Support for booking follow-up appointments [8140]",
        "Support for crediting participants of training [8132]",
        "Displaying cut-off times for same-day deliveries [7997]",
        "Proper PACE icon in browser tabs [8286]",
        "Advanced parsing of URLs in SAP long texts [8281]"
      ],
      "FIXED": [
        "Disabling upload/download buttons on the confirmation screen when offline [8006]",
        "Evaluation of used date in measurement equipments [8315]"
      ]
    }
  },
  {
    "version": "5.16.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Disabling the missing protocol justification."
      ]
    }
  },
  {
    "version": "5.16.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved an issue with the missing protocol submission."
      ]
    }
  },
  {
    "version": "5.16.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Updated the endpoint urls for get other tasks."
      ]
    }
  },
  {
    "version": "5.17.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Adding task numbers to the ATS form  [8152]",
        "Display the delivery cutoff time  [7512]",
        "Improving and generalising Azure functions [7977]",
        "Added option to report issues form PACE’s loading screen [8318]",
        "Disabling upload / download on barcode clipboard and timesheet in offline mode  [8337]",
        "Error modal [8335]"
      ],
      "FIXED": [
        "Properly handling State / Province for US  [8239]",
        "Fixing rendering of the bottom action bar on mobile views with long corners [7827]",
        "Fixing state of Start Work functionality  [8330]",
        "Fixing time recording on CRM screen  [8173]"
      ]
    }
  },
  {
    "version": "5.18.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "UI feedback for up- and download actions [8391]",
        "Improved error messages for timesheet [8301]"
      ],
      "FIXED": [
        "Fixing issues with TID details screen [8488]"
      ]
    }
  },
  {
    "version": "5.19.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "CRM Sign Later functionality speed improvement [8388]",
        "(UI) Improved Push Notifications visual guide for clarity [8382]",
        "Shipping Priority issues fixed [8508]",
        "Document Feedback error is now resolved [8522]",
        "Trainee Credit Type US/CAN now made mandatory field [7490]"
      ],
      "ADDED": [
        "Documenting reasons for not filling forms for confirmation [7916].",
        "Corporate Information updated [8500]."
      ]
    }
  },
  {
    "version": "5.19.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Updating the dashboard after Push Notifications [7490]"
      ]
    }
  },
  {
    "version": "5.20.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Multiple popups for Authentication [8534]",
        "Attaching screenshots for Reporting Issues [8490]",
        "Short Confirmation transition to Confirm Work [8469]",
        "Cross device Measurement Tools [8468]"
      ],
      "ADDED": [
        "Afterhours Call-Out [7917].",
        "Book appointment [3892]."
      ]
    }
  },
  {
    "version": "5.20.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Submitting notification after refreshing Details or Confirmation page throws error [8688]",
        "Not able to submit CRM for notifications having FDA forms [8661]"
      ]
    }
  },
  {
    "version": "5.21.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Improvmeents in FDA 2579 Form [8570]",
        "Remove MQ Notification No from Complains [8501]",
        "Capture access hours (PCH) [7179]",
        "Saving state on editing form [8352]",
        "Source Replacement [7521]",
        "GRL Radioactive survey report [7150]",
        "Support for AWB Packaging [7495]"
      ],
      "FIXED": [
        "Pickup address on Material Request issue [8566]",
        "Form list entries not dimmed [8560]",
        "Saving forms as submitted [8556]",
        "Submitting form with invalid field [8555]",
        "Availability of material for request now shown [8449]",
        "Freetext filling issue when it was mandatory [8184]"
      ]
    }
  },
  {
    "version": "5.21.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Issue with submitting CRMs [8691]"
      ]
    }
  },
  {
    "version": "5.22.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Upgrade encryption mechanics [8107]",
        "Automatically generating missing encryption keys [8106]",
        "Moving encryption keys to Azure vault [8105]"
      ],
      "FIXED": [
        "Material Pickup, Material Return and Material History screens that have AWB Packaging, Package RFID or UCR Numbers [8719]"
      ]
    }
  },
  {
    "version": "5.22.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Caching of the Azure encryption keys [8750]"
      ]
    }
  },
  {
    "version": "5.22.2",
    "summary": [],
    "changes": {
      "ADDED": [
        "Support for PCH alerts [8481]"
      ]
    }
  },
  {
    "version": "5.23.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Installation Paperwork [7178]",
        "Criticality Change - specific notification types[8558]",
        "Criticality Change - enable start date fields [8572]"
      ],
      "FIXED": [
        "Source Replacement - updated column headings[8748]"
      ]
    }
  },
  {
    "version": "5.23.1",
    "summary": [],
    "changes": {
      "ADDED": [
        "Improved camera selection for barcode scanning [8761]"
      ],
      "FIXED": [
        "Issues with encryption on client side"
      ]
    }
  },
  {
    "version": "5.23.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Improved init process to respect unreleased features [8792]"
      ]
    }
  },
  {
    "version": "5.23.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Caching of defining requests in offline store [8793]"
      ]
    }
  },
  {
    "version": "5.23.4",
    "summary": [],
    "changes": {
      "FIXED": [
        "Fixing issues with material pickup and material return related to RFID / AWB [8818]"
      ]
    }
  },
  {
    "version": "5.24.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "State and Province in forms for parts ordering [8239]",
        "Synchronisation of receipients in service reports [8375]",
        "Calendar icon for follow-up appointments [8319]",
        "Synchronisation of signature state [8380]",
        "PDF upload when reporting issues [8676]",
        "Navigation in confirmation summary [8715]",
        "Wording for radioactive surveys [8742]"
      ],
      "ADDED": [
        "Quick-select button for addresses in the timesheet [8396]",
        "Support for authentication via Auth0 (PACE for Partners) [8515]"
      ],
      "REMOVED": [
        "What's new icon [8814]"
      ]
    }
  },
  {
    "version": "5.24.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Commercial info for billable and non-billable material consumption [8083]",
        "Frozen screen when returning material [8782]"
      ]
    }
  },
  {
    "version": "5.25.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Optimizing StatesOfUSA dropdown[8720]",
        "Duration Field -Retain updated date input on Cancel[8724]"
      ]
    }
  },
  {
    "version": "5.25.1",
    "summary": [],
    "changes": {
      "ADDED": [
        "Restricting access to PACE for Partners for XGID users only [8822]"
      ]
    }
  },
  {
    "version": "5.25.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Start Work disabled after timesheet submission [8846]",
        "Issues opening PACE Forms [8871]"
      ],
      "ADDED": [
        "Extended logging and incident tracking [8867, 7892]"
      ]
    }
  },
  {
    "version": "5.25.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Resolved serialization inconsistencies affecting DOP data structures.",
        "Delivered a series of UI/UX enhancements to elevate the overall SPOT tool experience.",
        "Corrected cloning behavior of internal structures that previously led to resource exhaustion under specific conditions.",
        "Addressed a hanging storage event caused by an incomplete subscription workflow."
      ],
      "ADDED": [
        "Expanded diagnostic capabilities with improved logging and centralized error collection.",
        "Introduced trace-level insights to the issue reporting module for deeper visibility with troubleshooting."
      ]
    }
  },
  {
    "version": "5.25.4",
    "summary": [],
    "changes": {
      "FIXED": [
        "Caching issues with the PWA service worker."
      ]
    }
  },
  {
    "version": "5.26.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "State is displayed under region [8890]",
        "Shipping Priorities with ZPR indicator [9022]",
        "Radioactive survey made visible [8985]",
        "Physical Inventory [8422]",
        "Timesheet Refactoring [8933]",
        "Email generation after Timesheet submission [8982]",
        "Materials captured in return material screen [8943]",
        "Confirmation Summary - Text in Report Text field is now wrapped properly [8833]",
        "SPOT tool performance enhanced [8802]",
        "Interim forms submission status retained [8778]",
        "Uniformity maintained for Labels and Textfield Names [8773]",
        "Boot Stock filtering interference [8762]",
        "Material Availability- Text filed improved [8679]",
        "Dura task handled [8674]",
        "Material return count updated correctly [8551]",
        "Link is submitted correctly to PACE [8281]",
        "Timesheet refreshes on any activity [8270]",
        "“Marker for “sorting” is missing [8156]"
      ],
      "ADDED": [
        "Device Lock [9033]",
        "Enable “Left on Notification” and No AWB for SmartSensorTracker [8552]",
        "PACE can now support DURA tasks within the NDP workflow [8850]",
        "No approval needed when downgrading a task to partially down critical [8906]"
      ]
    }
  },
  {
    "version": "5.26.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Removed unrelated items from the activity dropdown on the confirmation time recording page [8740]",
        "When the same device and browser are used, provide an option to force-unlock the application [9049]"
      ]
    }
  },
  {
    "version": "5.26.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "Barcode Clipboard has fetch and upload buttons replaced with automatic save and load [9059]",
        "Confirmation's auto-save functionality was restored [9064]"
      ]
    }
  },
  {
    "version": "5.26.4",
    "summary": [],
    "changes": {
      "FIXED": [
        "Barcode Clipboard saves changes immediately after modifying the barcodes [9059, 9071, 9072, 9073]",
        "Timesheet introduced an additional safeguard that restores notification entries [9058, 8562]",
        "Bug where Checking in did not overwrite data with the incoming remote Data leading to notifications still being visible on the dashboard even after being already sent [9085]"
      ],
      "ADDED": [
        "Device lock popup can be closed on startup to reach report an issue [9085]",
        "Device lock supporting multiple tabs [9085]"
      ]
    }
  },
  {
    "version": "5.27.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Malfunction start time is displayed correctly on PACE [8809]",
        "Enhancements on FDA form [8926]",
        "“Radioactive survey” is missing [8985]",
        "PI - Alignment enhancement [8987]",
        "Shipping Priorities Conditions [9022]",
        "FDA forms performance enhanced [9025]",
        "Criticality Change wrong approver code fixed [9045]",
        "Installation paperwork submission issue fixed [9048]",
        "Time rounding Code aligned with Summary screen Labels [8849]",
        "Materials refactored [8943]",
        "Display Astoria forms [9044]",
        "PACE Spector: reset current timesheet fixed [9101]"
      ],
      "ADDED": [
        "Hide Timesheet [6964]",
        "Duration field from PACE to P58 and vice versa [7149]",
        "PACE can now support DURA tasks within the NDP workflow [8850]",
        "Pass DURA task number in POST request [9055]"
      ]
    }
  },
  {
    "version": "5.28.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Criticality can't be changed even after CSE confirms task [9169]",
        "Links in sidemeny [8811]",
        "Issue with backdating timesheet entries [8917]",
        "Time formatting in contract details [9046]",
        "Synchronisation timestamps [9093]",
        "Changing of criticality [9169]"
      ],
      "ADDED": [
        "Confirmation summary displays recipient list [6697]",
        "Hiding timesheet for NP00 [9124]",
        "Improving the appearance of the loading screen [9129]"
      ]
    }
  },
  {
    "version": "5.29.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Notification status update fixed once task is confirmed [9191]",
        "Issue of disappearing notification status on app refresh fixed [9139]",
        "Start on-site service is no longer possible with pending ATS form [9118]",
        "Report an issue failing on large payloads [9122]"
      ],
      "ADDED": [
        "Detect browser's incognito mode with a warning message [9062]",
        "PACE startup speed greatly improved [9107]",
        "Smart sensor link updated [9109]",
        "UI improvement to the Check-Out button [9110]",
        "Recipient list now on the confirmation summary [6697]",
        "Infrastructure for SmartLocker prepared [8860]",
        "Infrastructure for FedEx locations prepared [8907]",
        "Early Travel validation logic added - pending configuration [8919]",
        "Changes to the FDA2579 form [8983]",
        "Update of PACE Spector access code [9171]"
      ]
    }
  },
  {
    "version": "5.30.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Azure preparation to handle Fedex locations completed. [8559]",
        "Physical Inventory now handles batch numbers for materials. [8992, 8993]",
        "Return without consumption is now selectable for rental tools on the confirmation. [8336]"
      ],
      "FIXED": [
        "An issue related to downloading DocBox files has been fixed. [9193]",
        "The time for a timesheet submission has been greatly reduced. [9225]",
        "PACE is showing the work week hours again. [8446, 8852]",
        "The Timesheet's end-of-work issue with auto-resets and future end times has been fixed. [9004]",
        "A preliminary fix for the event date of the Physical Inventory feature is added. [9067, 9170]",
        "The remaining Cordova dependencies were removed. [7503]",
        "A dependency on the client services check for countries has been removed. [8186]"
      ]
    }
  },
  {
    "version": "5.30.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Restore backward compatibility for FDA form data structure. [9208]"
      ]
    }
  },
  {
    "version": "5.31.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "The option Bootstock Replenish has been added to material consumption. [8141]",
        "Fedex Locations are now available in the request material menu. [8070]",
        "The Get Other Tasks feature has been improved to load records when activating the customer tab. [8947]",
        "The FDA 2579 form has been reworked based on new requirements. [9208]",
        "Endpoints for Appointment Booking and Bootstock Return were added in Azure. [9212, 9213]"
      ],
      "FIXED": [
        "The check-out button is now disabled when offline. [9063]",
        "The Physical Inventory feature got reworked for better performance. [9000, 9217]",
        "An issue with the responsiveness of Physical Inventory has been resolved. [8999]",
        "Line breaks are now retained in the report text field of the service report. [9133]",
        "A validation issue has been fixed for DOP on material request. [9184]",
        "A defect when fetching the service key has been resolved. [9221]",
        "Additional information is now mandatory, when a follow-up is needed. [8564]",
        "A timezone related issue was corrected for status indication of \"overdue\" on notifications. [8825]",
        "A timezone related issue was corrected when showing physical inventory schedule dates for P5 countries. [9067]",
        "The early travel violation now displays the earliest travel time correctly, independent of timezone. [9200]",
        "The radioactive survey got a fix for missing data in the backend. [9209]",
        "The bootstock replenish feature got an update to its indicator logic and allows confirmation submission. [9210]",
        "The approver logic is now refined to not send the APPR code. [9215]",
        "The date and time information is now added to the YCCU APPR activity. [9216]"
      ]
    }
  },
  {
    "version": "5.32.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "QCA form integration into PACE. [8682]",
        "Generalization to extend the synchronization with other PACE apps. [9224]",
        "Extended logging and monitoring for error detection in Azure. [9239]",
        "Technical User mapping on Azure side. [9262]"
      ],
      "FIXED": [
        "Empty expenses tab at the timesheet. [9006]",
        "Unexpected user status changes. [9121]",
        "Confirmation down time start is now timezone proof. [9238]",
        "Issue with address handling that prevented bootup and CRM submission. [9281]"
      ]
    }
  },
  {
    "version": "5.32.1",
    "summary": [],
    "changes": {
      "ADDED": [
        "Support for force-unlocking sessions. [9316]",
        "Improved handling of hidden addresses in timesheets. [9317]",
        "Formatting of most relevant parts of the service keys.",
        "Navigating to dashboard after confirming a notification. [9277]"
      ]
    }
  },
  {
    "version": "5.32.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Missing notification and functional location in QCA report fixed. [9375]"
      ],
      "ADDED": [
        "New allow question combination on QCA form. [8805]"
      ]
    }
  },
  {
    "version": "5.32.3",
    "summary": [],
    "changes": {
      "FIXED": [
        "MQ notification description is now the short version of the problem statement of the QCA form. [9379]",
        "Maximum value length validation for contact person's name, phone and email have been updated. [9380]"
      ]
    }
  },
  {
    "version": "5.32.4",
    "summary": [],
    "changes": {
      "ADDED": [
        "Improving the function timeouts in Azure proxy service. [9413]"
      ]
    }
  },
  {
    "version": "5.32.5",
    "summary": [],
    "changes": {
      "ADDED": [
        "Updated country tech user mappings in constants. [9432]"
      ]
    }
  },
  {
    "version": "5.32.6",
    "summary": [],
    "changes": {
      "ADDED": [
        "Updated country tech user mappings for BG, CA, and US in constants."
      ]
    }
  },
  {
    "version": "5.33.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Boostock Scrap feature added. [8071]",
        "Boostock Return feature added. [8133]",
        "Physical Inventory form data is now saved. [8950]"
      ]
    }
  },
  {
    "version": "5.33.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "A boot stock material issue was fixed that froze the material screen. [9335]"
      ]
    }
  },
  {
    "version": "5.33.2",
    "summary": [],
    "changes": {
      "ADDED": [
        "Added serial number next to TID-No. on dashboard and detail screen. [9314]",
        "Improvements to boot stock scrap and return buttons and table sorting. [9327]"
      ]
    }
  },
  {
    "version": "5.33.3",
    "summary": [],
    "changes": {
      "ADDED": [
        "Technical User mapping included in all systems. [9262]"
      ]
    }
  },
  {
    "version": "5.34.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Remote task handling code changes were added in preparation for the feature. [8799]",
        "The report an issue feature got an improvement for prio 1a ticket creation. [9279]",
        "Spare parts catalogue is now available from multiple screen with QOL improvements. [9299]",
        "Azure Fx have been added in preparation for smart locker. [9322]",
        "Azure Fx improved debugging features. [9388, 9391]",
        "Measurement tools are now available in a short confirmation. [9349]"
      ],
      "FIXED": [
        "Azure Fx deployment slot target updated. [9196]",
        "The AWB packaging field is now retaining its value when returning to Material Return. [9347]"
      ],
      "REMOVED": [
        "The obsolete multi-device config parameter got removed. [9320, 9338]",
        "Code cleanup for the appointment booking feature. [9393]"
      ]
    }
  },
  {
    "version": "5.35.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "PACE Forms now allows for successive handovers from within PACE. [9416]",
        "A comment section was added in the materials tab of physical inventory. [9392]"
      ],
      "FIXED": [
        "SPQ data is now retained when switching devices. [9207]",
        "We optimized the size of stored measurement tools in a confirmation. [9300]",
        "Material pricing is now being displayed. [9358]",
        "The physical inventory is now triggering automatically when the scheduled date and time is reached. [9382]"
      ],
      "REMOVED": [
        "Removal of legacy confirmation storage in favor of concurrency store. [9290]",
        "Removal of legacy material storage in favor of concurrency store. [9291]"
      ]
    }
  },
  {
    "version": "5.35.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Appearance of the versioning screen",
        "Issue with synchronising confirmation data [9462]"
      ]
    }
  },
  {
    "version": "5.36.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Remote Task Handling - New Major CR Requirement CEECA [8543, 8755, 9421]"
      ],
      "FIXED": [
        "Material count is decreased on pickup. [7763]",
        "Unresponsive behavior for Physical Inventory was fixed. [9240]",
        "AWB Packaging barcode set up. [9351]",
        "Down time validation in the CRM was fixed. [9410]"
      ],
      "REMOVED": [
        "We removed doubled data storage for Timesheet, Notification Status and Physical Inventory. [9289, 9425, 9435]"
      ]
    }
  },
  {
    "version": "5.37.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Date format updated for measuring equipment. [9389]",
        "Material return now has the FedEx option available. [9433]"
      ],
      "FIXED": [
        "Issues concerning the timesheet addresses were resolved. [8829]",
        "Physical Inventory label alignment fixed. [9197]",
        "Sub equipments display behavior corrected. [9357]",
        "State now visible in notification details header. [9360]",
        "State is now prefilled in material request screen. [9361]",
        "Physical Inventory popup does not appear anymore when checked out. [9436]",
        "After hours call out is now sending \"Workcode\" via timesheet. [9449]"
      ],
      "REMOVED": [
        "Removed the client manager services from the address model. [9441]"
      ]
    }
  },
  {
    "version": "5.37.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Fixed an issue with sending the Material Return. [9486]"
      ]
    }
  },
  {
    "version": "5.37.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "Delayed submission of timesheets and confirmations. [9552]"
      ]
    }
  },
  {
    "version": "5.37.3",
    "summary": [],
    "changes": {
      "ADDED": [
        "Extended logging and custom events. [9567, 9558]"
      ]
    }
  },
  {
    "version": "5.37.4",
    "summary": [],
    "changes": {
      "FIXED": [
        "Reducing log size to counteract app crashes. [9673]"
      ]
    }
  },
  {
    "version": "5.38.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Functionality for Appointment Booking [3892]",
        "Frontend to handle Smartlocker Materials handling and Sorting [8799,8111]"
      ]
    }
  },
  {
    "version": "5.39.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "The material availability screen got a visual update. [8549]",
        "Extension of the Appointment Booking feature. [9179]",
        "RFID delivery mapping was introduced for the material consumption. [9348]",
        "The feature Installation Paperwork received a major change. [9418]"
      ],
      "FIXED": [
        "A visual glitch got fixed on the confirmation summary screen. [9185]",
        "The reverting \"Travel to\" entry was corrected. [9187]",
        "The logic for changing timesheet slots was updated. [9417, 9427]",
        "Signature is now recorded from PACE in offline mode. [9460]",
        "The issue of the physical inventory modal not opening is fixed. [9464]",
        "An issue with the \"Material request\" screen being unresponsive got solved. [9480]",
        "For Forms a defective component replacement display filled in fields. [9459]",
        "An issue where the CSE signature was missing on a PACE Form got fixed. [9496]"
      ]
    }
  },
  {
    "version": "5.40.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "PACE Forms are handed over automatically on checkout. [9069]"
      ]
    }
  },
  {
    "version": "5.41.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Improved logging mechanism to support the tracking client id. [9558]"
      ],
      "FIXED": [
        "An issue where the timesheet was sporadically interrupted was fixed. [9282]",
        "An issue was solved where completed confirmations were not being removed properly. [9301]",
        "Improved stability when reading data from shared devices. [9573]",
        "Followup section now opening correctly after appointment booking. [9556]",
        "Final form submission corrected after manual individualization. [9538]"
      ],
      "REMOVED": [
        "Code cleanup done for the equipment maintenance set. [9401]",
        "Legacy code for checking for P58 has now been removed. [9473]"
      ]
    }
  },
  {
    "version": "5.41.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "An issue concerning Follow-ups in Short Confirmations for Remote Task Handling. [9631]"
      ]
    }
  },
  {
    "version": "5.41.2",
    "summary": [],
    "changes": {
      "FIXED": [
        "The shown amount for bootstock items has been corrected. [9530]"
      ]
    }
  },
  {
    "version": "5.41.3",
    "summary": [],
    "changes": {
      "ADDED": [
        "The synchronized confirmations received a access guard and cleanup mechanism. [9658]"
      ],
      "FIXED": [
        "The datetime option for the follow-up's start immediately option got fixed. [9678]",
        "Better table indexing for IndexedDb storage. [9701]"
      ]
    }
  },
  {
    "version": "5.41.4",
    "summary": [],
    "changes": {
      "FIXED": [
        "Additional info text field is again included in the CrmHeaderSet. [9961]"
      ]
    }
  },
  {
    "version": "5.42.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "DocBox can now use the camera to upload images. [9467]",
        "Smartlocker sorting and pickup improvements. [9535]",
        "Unlimited forms handover improvements. [9554]",
        "Config Service for typed, event-driven configs. [9120]",
        "Serial number on physical inventory is editable now. [9572]",
        "Installation Paperwork section allows additional document uploads. [9577]",
        "The popup \"Attention PACE forms\" is suppressed when documents are uploaded for installation paperwork. [9580]",
        "Future dates for source replacement are now possible. [9599]",
        "The helium tracker link is added on installation paperwork. [9602]",
        "Logging improvements. [9619]"
      ],
      "FIXED": [
        "Connection to Snowflake was fixed. [9609]",
        "Bootstock quantity is showing the correct amount. [9530]",
        "Corrected the \"Track all orders\" link. [9469]",
        "Radioactive report values corrected. [9557]",
        "Other stock screen does not contain the scrap option anymore. [9563]",
        "FDA form conversion on installation paperwork section fixed. [9565]",
        "The IVK link on installation paperwork now links to the system configuration. [9578]",
        "Installation paperwork punchlist behavior has been updated. [9581]",
        "The activity codes on installation paperwork are now correctly timestamped. [9582]",
        "Conditions to force a follow-up have been updated to include installation paperwork. [9586, 9672]",
        "The form for the physical inventory is now blocked from triggering on locked out devices. [9608]",
        "Appointment booking date format got adapted to match the rest of the app. [9610]",
        "A sporadic bug where the PACE Forms don't open in edit mode has been fixed. [9684]"
      ],
      "REMOVED": [
        "The \"Open forms\" button was removed from some installation paperwork questions, such as IQAP. [9600]",
        "PACE Forms hiding options removed. [9629]"
      ]
    }
  },
  {
    "version": "5.43.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Smartlocker UI/UX improvements. [9650]"
      ],
      "FIXED": [
        "FDA form availability when sending confirmations. [9663]",
        "Time format when booking appointments. [9698]",
        "Issue with follow-up section in installation paperwork. [9704]",
        "Display of error messages in forms. [9732]"
      ]
    }
  },
  {
    "version": "5.44.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Travel time (Travel To and Travel Back) can now be split to report breaks for compliance. [9405]",
        "Material with non-countable units (e.g. meter, gram) is no longer automatically split into separate items. [9620]",
        "SmartLocker now displays the door ID consistently on all relevant screens. [9749]"
      ],
      "FIXED": [
        "Log identifiers for MatReturnHeaderSet and MatPickupHeaderSet have been corrected. [9724]",
        "Appointment end date now correctly updates when changing the number of days. [9731]",
        "SmartLocker now correctly shows an error message when a searched material is not found. [9738]",
        "The Sync button animation is working again. [9740]",
        "Raw translation keys no longer appear on the Summary screen. [9744]",
        "Travel time before a break is now correctly reflected in the summary screen. [9753]",
        "Material is no longer incorrectly split when reopening the material request screen. [9764]",
        "The \"Complete Open Punchlist\" follow-up type on installation paperwork is now created correctly. [9585]",
        "Installation paperwork text wrapping and alignment have been corrected. [9703]",
        "Travel breaks validation on the summary screen has been updated. [9519]"
      ]
    }
  },
  {
    "version": "5.44.1",
    "summary": [],
    "changes": {
      "FIXED": [
        "Scheduled PI date values will be processed as UTC and shown it in local user time zone [9864]"
      ]
    }
  },
  {
    "version": "5.45.0",
    "summary": [],
    "changes": {
      "FIXED": [
        "Component Information now available for non CT systems. [9966]",
        "Appointment Booking UTC time conversion implemented. [9903]",
        "Appointment booking slots now shown in local time. [9968]",
        "PI start time inconsistencies fixed. [9864]"
      ]
    }
  },
  {
    "version": "5.46.0",
    "summary": [],
    "changes": {
      "ADDED": [
        "Unify bootstock and other stock for smartlocker. [9571]"
      ],
      "FIXED": [
        "Checkout pipeline unblocked for forms handover."
      ]
    }
  },
  {
    "version": "6.0.0",
    "summary": [
      "A new engine under the hood: PACE gets a smarter state management core, a rebuilt timesheet, and a modernized backend connection."
    ],
    "changes": {
      "ADDED": [
        "PACE now runs on a modern state management engine (NgRx), making the app faster, more predictable, and easier to keep in sync.",
        "The timesheet has been rebuilt from the ground up for a smoother, more reliable time-tracking experience.",
        "The connection layer to our backend services has been fully modernized, improving stability and paving the way for faster future updates."
      ]
    }
  },
  {
    "version": "6.0.1",
    "summary": [
      "Multiple fixes for confirmation and timesheet"
    ],
    "changes": {
      "FIXED": [
        "Confirmation submit includes signature data [10039]",
        "Prevent notification with failed CRM from appearing on timesheet [10016]",
        "Weekly working time fix after app start [10015]",
        "Timesheet address displays customer name or address text correctly [9980]",
        "Duplicating a manually created timesheet address works as expected [10032]",
        "Unified layout of warnings in confirmation timerecording [9981]",
        "Changed severity of overlapping time recording for in-progress notifications to warning [10030]"
      ]
    }
  },
  {
    "version": "6.0.2",
    "summary": [
      "Prevent material data loss when submitting confirmation"
    ],
    "changes": {
      "FIXED": [
        "Fixed material data loss when a sync was triggered during confirmation filling [10049]"
      ]
    }
  },
  {
    "version": "6.0.3",
    "summary": [
      "Fix travel standby for Korea and offline mode"
    ],
    "changes": {
      "FIXED": [
        "Standby travel for Korea gets validated correctly [10059]",
        "Add user encryption data to service worker to enable offline mode again [10061]",
        "Updated credentials for connection to SHARP so that \"Report an issue\" works again"
      ]
    }
  }
];
